<template>
  <div class="home_page">
    <div class="banner">
      <div class="mini_txt">Algorithm capability</div>
      <div class="main_txt">科技改变未来</div>
      <img src="@/assets/images/banner-p1.png" alt="">
    </div>
<!--    <div class="home_c">-->
<!--      首页-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  mounted(){
    this.$emit('header_show', true);
    this.$emit('footer_show', true);
  }

}
</script>

<style scoped lang="less">
.home_page {
  width: 100%;
  margin: 0 auto;
  text-align: center;

  .banner {
    width: 100%;
    background: url('~@/assets/images/banner-bg.png') no-repeat center top;
    background-size: 100% 100%;
    position: relative;

    .mini_txt {
      position: absolute;
      top:228px;
      left: 44%;
      font-family: Myriad Pro;
      font-weight: 400;
      font-size: 30px;
      color: #b6bbd5;
      text-transform: uppercase;
    }

    .main_txt {
      position: absolute;
      top: 278px;
      left: 50%;
      transform: translateX(-53%);
      font-family: Source Han Sans CN;
      font-weight: bold;
      font-size: 60px;
      color: #FFFFFF;
    }
  }
}
</style>